import React, { useContext } from 'react';
import { Box, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';
import { OrganizationThemeContext } from '../../../lib/context/OrganizationThemeContext';

const useStyles = makeStyles((theme: Theme) => ({
  avatar: {
    alignItems: 'center',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
  },
  primary: {
    background: theme.palette.primary.main,
  },
  secondary: {
    background: theme.palette.secondary.main,
  },
  wrapperGrid: {
    alignItems: 'center',
    borderRadius: '4px',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
  },
  wrapperPrimary: {
    backgroundColor: `${theme.palette.primary.main}15`,
  },
  wrapperSecondary: {
    backgroundColor: `${theme.palette.secondary.main}15`,
  },
}));

interface ThemableBackgroundProps {
  children?: React.ReactNode;
  wrapperClassName?: string;
  avatarClassName?: string;
}

const ThemableBackgroundWithIcon: React.FC<ThemableBackgroundProps> = (
  props: ThemableBackgroundProps
) => {
  const classes = useStyles();

  const { children, wrapperClassName, avatarClassName } = props;

  const { hasCustomTheme } = useContext(OrganizationThemeContext);

  return (
    <Box
      className={classNames(
        classes.wrapperGrid,
        wrapperClassName,
        hasCustomTheme ? classes.wrapperPrimary : classes.wrapperSecondary
      )}
    >
      <Box
        className={classNames(
          classes.avatar,
          avatarClassName,
          hasCustomTheme ? classes.primary : classes.secondary
        )}
      >
        {children}
      </Box>
    </Box>
  );
};

export default ThemableBackgroundWithIcon;
